export default __webpack_public_path__ + "static/media/raiffeisen_s3.4f7668fe.png";